var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack139({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,2.54C4,2.54.8,4.51.8,6.94c0,1.46,1.17,2.75,3,3.55a5.16,5.16,0,0,1-.43.61,5.39,5.39,0,0,1-2.6,1.75A5.43,5.43,0,0,0,5.35,11,11.51,11.51,0,0,0,8,11.35c4,0,7.24-2,7.24-4.41S12,2.54,8,2.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack139);
export default __webpack_public_path__ + "static/media/Symbolpack_1_39.a750314a16c8dad1179a9fe9b762c5a6.svg";
export { ForwardRef as ReactComponent };